import React from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "~/ui-kit/components/Typography/Typography";

export const InstructionsCard = () => {
  const { t } = useTranslation();
  return (
    <div className="card">
      <div className="card-body">
        <div className="mb-2 text-center grey-900-c">
          <Typography size="lg" weight="bd">
            {t("backend:login_overview_header")}
          </Typography>
        </div>
        <Typography
          size="sm"
          weight="rg"
          element="p"
          className="text-center grey-500-c mb-0"
        >
          {t("backend:login_overview_text_1")}
        </Typography>
        <Typography
          size="sm"
          weight="rg"
          element="p"
          className="text-center grey-500-c mb-0 mt-2"
        >
          {t("backend:login_overview_text_2")}
        </Typography>
        <Typography
          size="sm"
          weight="rg"
          element="p"
          className="text-center grey-500-c mb-0 mt-2"
        >
          {t("backend:login_overview_text_3")}
        </Typography>
      </div>
    </div>
  );
};
